// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.final-checks-page {
  padding: 16px 24px;
}

.page-header {
  margin-bottom: 16px;
}

.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
}

.page-title {
  margin: 0;
  font-size: 24px;
  color: #0b2d71;
  display: flex;
  align-items: center;
  gap: 10px;
}

.release-name-badge {
  font-size: 14px;
  font-family: "Gotham", Arial, sans-serif;
  color: #0066b2;
  background: #e3f2fd;
  padding: 2px 10px;
  border-radius: 12px;
}

.refresh-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.back-button {
  margin-bottom: 8px;
  cursor: pointer;
  color: #0066b2;
  border-color: #0066b2;
  background-color: #fff;
  border-radius: 5px;
}

.release-button {
  min-width: 100px;
}

.tab-content-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.inline-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
}

.tab-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.tab-badge {
  display: inline-flex;
  align-items: center;
  background: transparent;
}
.tab-badge .badge-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.tab-badge.badge-ok .badge-icon {
  color: #388e3c;
}
.tab-badge.badge-warning {
  background: transparent;
}
.tab-badge.badge-warning .badge-icon {
  color: #f57c00;
}
.tab-badge.badge-error {
  background: transparent;
}
.tab-badge.badge-error .badge-icon {
  color: #97002e;
}

.status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-family: "GothamBold", Arial, sans-serif;
}
.status-badge.badge-ok {
  background: #e8f5e9;
  color: #388e3c;
}
.status-badge.badge-error {
  color: #97002e;
}
.status-badge.badge-warning {
  color: #e65100;
}

.severity-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-family: "GothamBold", Arial, sans-serif;
  white-space: nowrap;
}
.severity-badge.severity-info {
  background: #e3f2fd;
  color: #1565c0;
}
.severity-badge.severity-ok {
  background: #e8f5e9;
  color: #388e3c;
}
.severity-badge.severity-warning {
  background: #fff8e1;
  color: #e65100;
}
.severity-badge.severity-user-overridable {
  background: #fff3e0;
  color: #bf360c;
}
.severity-badge.severity-blocking {
  background: #ffebee;
  color: #97002e;
}
.severity-badge.severity-draft {
  background: #e3f2fd;
  color: #1565c0;
}

.valve-status-toolbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.proceed-without-updates-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 14px;
  margin-bottom: 12px;
  border: 1px solid #f0c36d;
  border-left: 4px solid #e0a800;
  border-radius: 4px;
  background-color: #fdf7e6;
}

.proceed-without-updates-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  color: #6b5310;
}

.proceed-without-updates-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #a37800;
}

.valve-flag-chip, .valve-status-chip {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.valve-status-chip.draft-status {
  color: #751569;
  background-color: #f5e8f4;
  border: 1px solid #c98ac4;
}
.valve-status-chip.review-status {
  color: #1a7fa0;
  background-color: #e5f6fd;
  border: 1px solid #5cc0e7;
}
.valve-status-chip.review-rejected-status {
  color: #a02020;
  background-color: #fdf0f0;
  border: 1px solid #d9534f;
}
.valve-status-chip.review-pending-comments-status, .valve-status-chip.approval-pending-comments-status {
  color: #8a5a00;
  background-color: #fdf5e6;
  border: 1px solid #e0b268;
}
.valve-status-chip.ready-to-publish-status {
  color: #0066b2;
  background-color: #e3f0fb;
  border: 1px solid #80b8df;
}
.valve-status-chip.published-status {
  color: #1a6b3a;
  background-color: #e8f5ee;
  border: 1px solid #7ebc9a;
}
.valve-status-chip.retired-status {
  color: #555;
  background-color: #f0f0f0;
  border: 1px solid #bbb;
}
.valve-status-chip.retiring-status {
  color: #0066b2;
  background-color: #e3f2fd;
  border: 1px solid #90caf9;
}
.valve-status-chip.newer-published-status {
  color: #8a5a00;
  background-color: #fdf5e6;
  border: 1px solid #e0b268;
}
.valve-status-chip.newer-draft-status {
  color: #555;
  background-color: #f0f0f0;
  border: 1px solid #bbb;
}
.valve-status-chip.outside-selected-release-status {
  color: #555;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  margin-left: 6px;
}
.valve-status-chip.rejected-status {
  color: #9b2020;
  background-color: #fdf0f0;
  border: 1px solid #e09090;
}
.valve-status-chip.unknown-status {
  color: #555;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
}

.valve-flag-chip {
  margin-right: 6px;
}
.valve-flag-chip.flag-disabled {
  color: #9b2020;
  background-color: #fdf0f0;
  border: 1px solid #e09090;
}
.valve-flag-chip.flag-newer-version {
  color: #8a5a00;
  background-color: #fdf5e6;
  border: 1px solid #e0b268;
}
.valve-flag-chip.flag-newer-version-draft {
  color: #555;
  background-color: #f0f0f0;
  border: 1px solid #bbb;
}

.no-permission-label {
  font-size: 0.75rem;
  font-style: italic;
  color: #888;
}

.valve-description-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.release-as-is-warning {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  padding: 8px 12px;
  border-radius: 4px;
  background: #ffebee;
  color: #97002e;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 13px;
}

.release-as-is-warning-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #97002e;
}

.validation-chip {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  margin-right: 4px;
  cursor: default;
}
.validation-chip.severity-info {
  background: #e3f2fd;
  color: #1565c0;
}
.validation-chip.severity-warning {
  background: #fff8e1;
  color: #e65100;
}
.validation-chip.severity-user-overridable {
  background: #fff3e0;
  color: #bf360c;
}
.validation-chip.severity-blocking {
  background: #ffebee;
  color: #97002e;
}

.no-validations {
  color: #999;
}

.tab-content {
  padding: 16px 0;
}

.tab-spinner-container {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.check-table {
  width: 100%;
}
.check-table th.mat-header-cell,
.check-table td.mat-cell {
  padding: 8px 12px;
  font-size: 13px;
}
.check-table th.mat-header-cell {
  font-family: "GothamBold", Arial, sans-serif;
  color: #0b2d71;
  background: #f5f5f5;
}

.full-width-table {
  width: 100%;
}

.no-data-cell {
  text-align: center;
  padding: 24px;
  color: #888;
  font-style: italic;
}

mat-expansion-panel {
  margin-bottom: 12px;
}

.section-count {
  font-family: "Gotham", Arial, sans-serif;
  font-size: 13px;
  color: #666;
  margin-left: 6px;
}

tr.mismatch-row td {
  background: #fff8e1;
}

tr.resolved-row td {
  background: #f1f8f2;
  color: #4f6352;
}

.description-choice-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.4;
}
.description-choice-label input[type=radio] {
  accent-color: #0066b2;
  cursor: pointer;
  flex-shrink: 0;
}

.description-edit-input {
  display: block;
  width: 100%;
  margin-top: 4px;
  padding: 4px 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.description-edit-input:disabled {
  background-color: #f0f0f0;
  color: #888;
  cursor: not-allowed;
}

.warning-icon {
  color: #f57c00;
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.resolved-description-icon {
  color: #388e3c;
  font-size: 18px;
  width: 18px;
  height: 18px;
}

tr.replaced-row td {
  background: #f1f8e9;
}

tr.needs-replacement-row td {
  background: #fff3e0;
}

.mismatch-cell {
  font-style: italic;
}

.acknowledged-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #388e3c;
  font-size: 13px;
}

.acknowledged-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #388e3c;
}

.general-details-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-card {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  padding: 16px;
  max-width: 600px;
}
.detail-card .detail-row {
  display: flex;
  gap: 12px;
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}
.detail-card .detail-row:last-child {
  border-bottom: none;
}
.detail-card .detail-label {
  font-family: "GothamBold", Arial, sans-serif;
  color: #0b2d71;
  min-width: 160px;
}
.detail-card .detail-value {
  color: #333;
}

.summary-counts {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 10px;
}
.summary-counts .count-item {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.summary-counts .count-label {
  font-size: 13px;
  color: #555;
}
.summary-counts .count-value {
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 18px;
  color: #0b2d71;
}

.attributes-form-container {
  max-width: 560px;
  padding-top: 8px;
}

.auto-save-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #888;
  font-size: 13px;
  margin-bottom: 12px;
}

.attributes-form {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.form-field-full {
  width: 100%;
}

.readonly-fields {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
  padding: 12px;
  background: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.readonly-field {
  display: flex;
  gap: 12px;
}
.readonly-field .readonly-label {
  font-family: "GothamBold", Arial, sans-serif;
  color: #0b2d71;
  min-width: 140px;
}
.readonly-field .readonly-value {
  color: #333;
}

.field-help-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  vertical-align: middle;
  margin-left: 4px;
  color: #888;
  cursor: help;
}

.name-uniqueness-hint {
  font-size: 0.8rem;
  color: #888;
  margin: -8px 0 12px;
  font-style: italic;
}

.empty-message {
  text-align: center;
  color: #888;
  font-style: italic;
  padding: 32px;
}

.pipe-class-action-badge {
  font-size: 12px;
  font-family: "Gotham", Arial, sans-serif;
  background: #e3f2fd;
  color: #0066b2;
  border-radius: 10px;
  padding: 1px 8px;
  margin-left: 10px;
}

.has-inactive-indicator {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #e65100;
  margin-left: 12px;
}

.inactive-warning-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.inactive-pipe-class-panel .mat-expansion-panel-body {
  padding: 0;
}

.original-code-label {
  font-size: 11px;
  color: #c62828;
  text-decoration: line-through;
  margin-right: 6px;
}

.no-data-message {
  color: #888;
  font-style: italic;
  padding: 24px;
  text-align: center;
}

.pipe-class-link {
  color: #0066b2;
  cursor: pointer;
  text-decoration: none;
}
.pipe-class-link:hover, .pipe-class-link:focus {
  color: #0066b2;
  text-decoration: underline;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
